import {Button, InputGroup, Form} from "react-bootstrap";
import React, {useEffect, useState} from "react";

export function AdjustQuantity({value, onChange, onDecrement, onIncrement, onBlur, ch = 7}) {
    return <div>
        <InputGroup className="flex-nowrap ">
            <Button variant="outline-secondary" className="border-light-subtle" onClick={onDecrement} disabled={value === 1}>
                <i className="bi bi-dash"/>
            </Button>
            <Form.Control
                aria-label="quantity"
                aria-describedby="quantity"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                className="text-center border-light-subtle"
                style={{width: `${ch}ch`}}
            />
            <Button variant="outline-secondary" className="border-light-subtle" onClick={onIncrement}>
                <i className="bi bi-plus"/>
            </Button>
        </InputGroup>
    </div>
}

export function AdjustQuantityCart({name, value, onChange, ch = 7}) {
    const [quantity, setQuantity] = useState(value);

    useEffect(() => {
        if (quantity !== value) {
            onChange({ target: { name, value: quantity } });
        }
    }, [quantity, name, onChange, value])

    const OnIncrement = () => {
        setQuantity((prevQuantity) => prevQuantity + 1)
    }
    const onDecrement = () => {
        setQuantity((prevQuantity) => (prevQuantity > 1 ? prevQuantity - 1 : 1))
    };

    const handleBlur = () => {
        if (quantity === "") {
            setQuantity(1);
        }
    }

    const handleChange = (e) => {
        const newValue = Number(e.target.value) || "";
        setQuantity(newValue);
    }

    return <div>
        <InputGroup className="flex-nowrap ">
            <Button variant="outline-secondary" className="border-light-subtle" onClick={onDecrement} disabled={quantity === 1}>
                <i className="bi bi-dash"/>
            </Button>
            <Form.Control
                name={name}
                min={1}
                aria-label="quantity"
                aria-describedby="quantity"
                value={quantity}
                onChange={handleChange}
                onBlur={handleBlur}
                className="text-center border-light-subtle"
                style={{width: `${ch}ch`}}
            />
            <Button variant="outline-secondary" className="border-light-subtle" onClick={OnIncrement}>
                <i className="bi bi-plus"/>
            </Button>
        </InputGroup>
    </div>
}
